module.exports = __webpack_public_path__ + "assets/img/8cdbb5ab92895165b36f771361ca34c5.png";